// extracted by mini-css-extract-plugin
module.exports = {"copy":"social_copy__qPs_B","copyLink":"social_copyLink__sDQUH","Share":"social_Share__I8zCi","icon":"social_icon__TLsp4"};